import 'vanilla-cookieconsent/dist/cookieconsent.css';

import * as CookieConsent from "vanilla-cookieconsent";

import { createConsentServices } from './ConsentServices';

const revision = 6

const cc = CookieConsent

window.cc = cc

const services = createConsentServices({
    consent: cc,
    window,
    document,
    loadSentry: () => import('@sentry/browser'),
    sentryOptions: {
        dsn: import.meta.env.VITE_SENTRY_DSN,
        release: window.appVersion,
        sendDefaultPii: true,
        tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE) || 0,
        tracePropagationTargets: ['localhost', /^https:\/\/sbahn-meldungen\.de\/api/],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    },
})

cc.run({
    mode: 'opt-in',
    revision,
    guiOptions: {
        consentModal: {
            layout: 'box wide',
            position: 'middle center',
        }
    },

    disablePageInteraction: true,

    onFirstConsent: () => {
        logConsent()
    },

    onChange: () => {
        logConsent()

        if (services.requiresReload()) {
            window.location.reload()
        }
    },

    categories: {
        necessary: {
            enabled: true,  // this category is enabled by default
            readOnly: true  // this category cannot be disabled
        },
        analytics: {
            enabled: false,
            readOnly: false,
            services: {
                matomo: {
                    label: 'Matomo',
                    onReject: services.rejectService,
                    cookies: [
                        { name: /^_pk_/ },
                        { name: 'mtm_consent' },
                        { name: 'mtm_cookie_consent' },
                    ],
                },
                sentry_io: {
                    label: 'Sentry.io',
                    onAccept: services.enableSentry,
                    onReject: services.rejectService,
                    cookies: [{ name: /^sentryReplaySession/ }],
                },
            },
        },
        marketing: {
            enabled: false,
            readOnly: false,

            services: {
                adsbygoogle: {
                    label: 'Google AdSense',
                    onAccept: services.enableAds,
                    onReject: services.rejectService,
                    cookies: [
                        { name: /^__gads$|^__gpi$|^__eoi$|^_gcl_/ },
                    ],
                },
            },
        }
    },
    language: {
        default: 'de',

        translations: {
            de: {
                consentModal: {
                    title: 'Wir nutzen Cookies',
                    description: 'Wir verwenden erforderliche Cookies für den Betrieb der Website. Mit deiner Zustimmung nutzen wir Matomo zur Reichweitenmessung, Sentry zur Fehleranalyse und Google AdSense für Werbung. Du kannst alle optionalen Dienste ablehnen und deine Auswahl jederzeit ändern.',
                    acceptAllBtn: 'Alle akzeptieren',
                    acceptNecessaryBtn: 'Alle ablehnen',
                    showPreferencesBtn: 'Individuelle Konfiguration'
                },
                preferencesModal: {
                    title: 'Cookie Einstellungen',
                    acceptAllBtn: 'Alle akzeptieren',
                    acceptNecessaryBtn: 'Alle ablehnen',
                    savePreferencesBtn: 'Aktuelle Einstellungen speichern',
                    closeIconLabel: 'Cookie Einstellungen schließen',
                    sections: [
                        {
                            title: 'Verwendung von Cookies',
                            description: 'Wir verwenden Cookies, um die grundlegenden Funktionen der Website zu gewährleisten und um dein Online-Erlebnis zu verbessern. Du kannst für jede Kategorie wählen, welche Dienste du erlauben möchtest. Deine Einwilligung kannst du jederzeit über die Cookie-Einstellungen widerrufen.'
                        }, {
                            title: 'Erforderliche Cookies',
                            description: 'Diese Dienste sind für die korrekte Funktion dieser Website unerlässlich. Sie können nicht deaktiviert werden, da die Website sonst nicht richtig funktionieren würde.',
                            linkedCategory: 'necessary'
                        }, {
                            title: 'Reichweitenmessung und Fehleranalyse',
                            description: 'Matomo erfasst Besucherstatistiken. Sentry erfasst technische Fehler, Leistungsdaten und gegebenenfalls Sitzungsaufzeichnungen. Dabei können personenbezogene Daten verarbeitet werden. Beide Dienste sind optional und können einzeln aktiviert werden.',
                            linkedCategory: 'analytics'
                        }, {
                            title: 'Marketing',
                            description: 'Google AdSense stellt Werbung bereit und kann dafür Cookies sowie weitere Daten verarbeiten. Die Auswahl zu Werbepartnern und personalisierter Werbung erfolgt zusätzlich über Googles Einwilligungsdialog, sobald du AdSense hier aktivierst.',
                            linkedCategory: 'marketing'
                        }, {
                            title: 'Mehr Informationen',
                            description: 'Informationen zur Datenverarbeitung findest du in der <a href="/datenschutzerklaerung">Datenschutzerklärung</a>.'
                        }
                    ]
                }
            }
        }
    }
})

function logConsent() {
    const cookie = cc.getCookie();
    const preferences = cc.getUserPreferences();

    const userConsent = {
        consentId: cookie.consentId,
        acceptType: preferences.acceptType,
        acceptedCategories: preferences.acceptedCategories,
        acceptedServices: preferences.acceptedServices,
        revision,
    };

    fetch('/api/cookie-consent', {
        method: 'POST',
        keepalive: true,
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json, text-plain, */*",
            "X-Requested-With": "XMLHttpRequest",
            "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? ''
        },
        body: JSON.stringify(userConsent)
    }).then(response => {
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`)
        }
    }).catch(error => {
        console.error('Die Cookie-Einwilligung konnte nicht protokolliert werden:', error)
    })
}
